'use client'
import React, { useCallback } from 'react'
import DropdownIndicator from './DropdownIndicator'
import ReactSelect, { StylesConfig } from 'react-select'
import { useBreakpoint } from '@l2p/apps-shared'
import './styles.scss'
import { useTranslations } from 'next-intl'

export interface IOption {
  label: string
  value: string | number
}

export interface IGroupedOption {
  label: string
  options: IOption[]
}

interface InputSelectSecondaryProps {
  inputName?: string
  options: IOption[] | IGroupedOption[]
  onChange?: (newValue: any) => void
  value?: any
  callSubmit?: () => void
  isDisabled?: boolean
  isSearchable?: boolean
  placeholder?: string
  labelText?: string
  fixedIcon?: string
  onBlur?: (newValue: any) => void
  isMulti?: boolean
  defaultValue?: any
  isClearable?: boolean
}

const selectStyles: StylesConfig = {
  control: css => ({ ...css, paddingLeft: '1rem' }),
}
const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}
const formatGroupLabel = (data: any) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
)

const InputSelectSecondary: React.FC<InputSelectSecondaryProps> = ({
  labelText,
  inputName,
  onChange,
  callSubmit,
  placeholder,
  isMulti,
  isClearable,
  isSearchable,
  ...props
}) => {
  const breakpoints = useBreakpoint()
  const t = useTranslations('translation')

  const onChangeHandler = useCallback(
    (event: any) => {
      if (onChange) onChange(event)
      if (callSubmit) callSubmit()
    },
    [callSubmit, onChange],
  )

  return (
    <div className="inputWrapperSecondary">
      <div className="selectWrapper">
        <ReactSelect
          {...props}
          isClearable={Boolean(isClearable)}
          options={props.options as any}
          noOptionsMessage={() => t('emptyOptions')}
          isLoading={false}
          classNamePrefix="react-select"
          isSearchable={breakpoints.mobile ? false : isSearchable}
          placeholder={placeholder ? placeholder : t('select')}
          onChange={onChangeHandler}
          components={{
            DropdownIndicator,
          }}
          styles={selectStyles}
          formatGroupLabel={formatGroupLabel}
        />
      </div>
    </div>
  )
}

export default React.memo(InputSelectSecondary)
